module.exports = __webpack_public_path__ + "files/fff453a9fe981e08b45ec9df9ed73b9c.png";